// extracted by mini-css-extract-plugin
export var divider = "_ff-7";
export var itemsToggle = "_ff-8";
export var mergeModal = "_ff-1";
export var optionCard = "_ff-4";
export var radioGroup = "_ff-6";
export var radioOption = "_ff-0";
export var selected = "_ff-5";
export var shipmentOptions = "_ff-2";
export var tableOptions = "_ff-3";